module.exports = __webpack_public_path__ + "static/media/quiz.b5cd28a9.png";